import { MbeBox } from '@/components/icons';
import { ROUTE_PATHS } from '@/constants';
import { Button, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const EmptyQuoteCard = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Flex
      alignItems="center"
      border={2}
      borderColor="brand.gray"
      borderStyle="dashed"
      direction="column"
      gap={4}
      justifyContent="center"
      px={8}
      py={20}
      w="full"
    >
      <MbeBox h={40} w={40} />
      <Text textAlign="center">{t('ACCOUNT.DASHBOARD.NO_QUOTES')}</Text>
      <Button as="a" href={`/${ROUTE_PATHS.quote}`} variant="mbePrimary">
        {t('ACCOUNT.MENU.CTA')}
      </Button>
    </Flex>
  );
};
